import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Catch-all Handler.
 *
 * If unauthed, sends to the Unauthed app at /login
 *
 * If authed, sends to the root of the app to be redirected by the app.
 * */
export default function CatchAll() {
  const { auth0AccessToken } = useAuth();
  const location = useLocation();

  if (!auth0AccessToken) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Navigate to="/" replace />;
}
